import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import {
  faHome,
  faUserInjured,
  faCalendarCheck,
  faUserCog,
  faBuilding,
  faCog,
  faStethoscope,
  faUsers
} from '@fortawesome/free-solid-svg-icons';

export interface NavigationItem {
  name: string;
  href: string;
  icon: IconDefinition;
  key: string;
}

export interface NavigationItemWithCurrent extends NavigationItem {
  current: boolean;
}

// Admin navigation items
export const ADMIN_NAVIGATION: NavigationItem[] = [
  {
    name: 'Organizações',
    href: '/admin',
    icon: faBuilding,
    key: 'admin-organizations'
  }
];

// Regular navigation items
export const REGULAR_NAVIGATION: NavigationItem[] = [
  {
    name: 'Dashboard',
    href: '/',
    icon: faHome,
    key: 'dashboard'
  },
  {
    name: 'Pacientes',
    href: '/pacientes',
    icon: faUserInjured,
    key: 'pacientes'
  },
  {
    name: 'Consultas',
    href: '/consultas',
    icon: faCalendarCheck,
    key: 'consultas'
  },
  {
    name: 'Atendimentos',
    href: '/atendimentos',
    icon: faUsers,
    key: 'atendimentos'
  }
];

// Utility function to add current state to navigation items
export const getNavigationWithCurrentState = (
  pathname: string,
  navigation: NavigationItem[]
): NavigationItemWithCurrent[] => {
  return navigation.map(item => ({
    ...item,
    current: isCurrentPath(pathname, item.href)
  }));
};

// Helper function to determine if a path is current
const isCurrentPath = (pathname: string, href: string): boolean => {
  // Exact match for home/dashboard
  if (href === '/') {
    return pathname === '/';
  }
  // Includes match for other paths
  return pathname.includes(href);
};

// Page icon mapping for header (used in getPageIcon function)
export const PAGE_ICON_MAP: Record<string, IconDefinition> = {
  '/': faHome,
  '/pacientes': faUserInjured,
  '/consultas': faStethoscope,
  '/atendimentos': faUsers,
  '/users': faUserCog,
  '/admin': faCog
};

// Utility function to get page icon based on pathname
export const getPageIcon = (pathname: string): IconDefinition => {
  // Check for exact matches first
  if (PAGE_ICON_MAP[pathname]) {
    return PAGE_ICON_MAP[pathname];
  }

  // Check for partial matches
  for (const [path, icon] of Object.entries(PAGE_ICON_MAP)) {
    if (path !== '/' && pathname.includes(path)) {
      return icon;
    }
  }

  // Default to home icon
  return faHome;
};
